import { ChatIcon, CollectionIcon, GearIcon } from '@design-systems/react-icons'
import { PERMISSIONS } from '../roleAccess/config/roleConfig'
import { ROUTE_ASSISTANT, ROUTE_BRANDS, ROUTE_SETTINGS } from '../routes/routes'

export const navigationConfig = Object.freeze([
  {
    id: 'assistant',
    label: 'Assistant',
    icon: ChatIcon,
    path: ROUTE_ASSISTANT,
  },
  {
    id: 'brands',
    label: 'Brands',
    icon: CollectionIcon,
    path: ROUTE_BRANDS,
    permission: PERMISSIONS.VIEW_BRANDS,
  },
  {
    id: 'settings',
    label: 'Settings',
    icon: GearIcon,
    path: ROUTE_SETTINGS,
    permission: PERMISSIONS.MANAGE_SETTINGS,
    section: 'Tools',
  },
])
